function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoO2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Ebene 1",
  viewBox: "0 0 173.459 100.108"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M5.6 0h162.2a5.6 5.6 0 0 1 5.7 5.6v88.9a5.6 5.6 0 0 1-5.7 5.6H5.6A5.6 5.6 0 0 1 0 94.5V5.6A5.6 5.6 0 0 1 5.6 0",
  style: {
    fill: "#0e1f7f"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.3 43c0-10.6 5.8-20.8 17.4-20.8 11.8 0 17.7 10 17.7 20.8 0 10.6-5.3 20.8-17.7 20.8-12.2 0-17.4-10.4-17.4-20.8m-10.8 0c0 18 10.2 30.5 28.2 30.5 18.1 0 28.5-12.6 28.5-30.5 0-17.5-10.5-30.4-28.5-30.4-17.8 0-28.2 13-28.2 30.4m54.1 44.5v-4.1c2.2-2 10.6-9 10.6-13.6 0-2.2-2-3.3-4-3.3a10.7 10.7 0 0 0-5.7 2l-.4-4.2a17.6 17.6 0 0 1 7.4-1.7c4.6 0 7.5 2.4 7.5 7.2 0 5.2-5.2 10-9.1 13.8h10v4z",
  style: {
    fill: "#fff"
  }
}));
export default SvgLogoO2;